<span class="truncate-text-wrapper">
  <span class="truncate-content">
    {{ isExpanded ? cleanedText : (needsTruncation ? truncatedText : cleanedText) }}
  </span>
  <button
    *ngIf="needsTruncation"
    type="button"
    class="ver-mais-btn"
    (click)="toggle($event)"
  >
    {{ isExpanded ? 'Ver menos' : 'Ver mais' }}
  </button>
</span>
